import React from 'react'
import Socials from '../Components/SocialMedia'
import NavDots from '../Components/NavigationDots'

const AppWrapper = (Component, idName, classNames) => function HOC() {
  return (
    <div id={idName} className={`app__container ${classNames}`}>
        <Socials />
        <div className="app__wrapper app__flex">
            <Component />
            <div className="copyright">
                <p className="p-text">@2020 JUBA</p>
                <p className="p-text">All Rights Reserved</p>
            </div>
        </div>
        <NavDots active={idName} />
    </div>
  ) 
}

export default AppWrapper